import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth72: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41.3,107.3h48s-23.6,69.5-48,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '18.9 81.2 119.4 81.2 123.8 84.4 125.7 87.2 128 91.2 128.7 94.9 128.6 98.7 128.6 102.2 9.9 102.4 9.1 99.8 9.1 97.1 9.1 92.8 9.1 90.6 10.3 87.1 13.2 84.5 18.9 81.2',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M28.4,74.7l-8.8,5.4-6.4,4.4-2.9,2.6-1.3,3.5v9.1l.9,2.7,3.3,9.5,3.8,7.1s31.1-15.9,11.4-44.4Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M103.6,73.7l15.8,7.5,4.3,3.2,4.3,6.8.6,3.7v7.3c0,0-2.6,9.1-2.6,9.1l-5.4,8s-30.4-17.3-17-45.6Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M9.3,90.8s68.2,16.4,116.9-2.9l2.5,5.9.3,8.3-1,5.1-1,3.3-4.5,7.2-4.5,4.9-6.7,6.5-4.5,2.7-8.3,4.4-8,2.7-6.5,2.1-6.2,1.9-5.8,1.5-4.2.7-9.7-.2-7.9-1.4-6.8-2-7.2-2.8-5.2-2.9-5.1-4.8-4.4-4.5-3.7-5.2-3.7-6.2-2.5-6.9-1.9-6.4-1-6.2.6-4.8Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M9.3,90.8l1-4.3,8.7-5.5,9.3-6.2,6.2-5.1,6.8-5.8,6.6-5.2,5.3-3.5,5.1-2.6,3-1.7,3-.9,10.6.3,4.6,1.7,4.3,3.1,5.1,3.7,5.5,4.9,4.4,4.6,3.3,3.3,2.9,2.6,6,2.2,6.1,2.9,5,2.9,2.7,3.4,1.6,2.4s-39.7,19.2-116.9,2.9Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M89.5,138.6c-8.7,2.4-17.2,6.3-26.5,6.1s-21.1-4.3-30.9-8.8c-12.2-9.7-20.2-22.6-22.7-38.2s-.3-9.6,2.4-11.7c7.8-6.3,17.8-11.4,27.3-19.9s27-21.7,42-12.2c14.1,8.9,17.8,19.6,31.8,24.2s13.8,8,15.3,16.6c3.5,19.8-18.1,38.3-38.7,43.9Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M87.4,386.6A11,11 0 1 0 65.4,386.6A11,11 0 1 0 87.4,386.6Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.4,399.6l-1.2,25.5s37.8-13.1,1.2-25.5Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.5,398.2l1.6,8.9,1.5,8.5.6,6.2v3.3c.1,0-36.7-13.4-3.7-27Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36.3,364.8s34.9-32.4,76.6-.2l-1.2-8.5s-35.6-29.3-73.7-.3l-1.7,9.1Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.5,375.4l-3.2,24.2-1.2,25.5-.7,23.9,1.6,7.9.8,2.6,1.1,1.3,2.7,2.4,3,.6,10.1.2h14.7c0,0,1.3-79.2-28.9-88.6Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M116.3,374.9l1.6,3.9,1.6,5.2,1.5,5.7,1.4,5v3.6c0,0,3.2,17.5,3.2,17.5l.6,6.2v3.3c.1,0,1.2,5.2,1.2,5.2v16.7l-1.4,5.3-2.8,3.8-3.4,3-3.2,1.7-5.1,2-5.7,1.2-11.9.3s.1-89.6,22.5-89.6Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36.3,364.8l-2.8,10.5-3.2,24.2-1.4,31.2-.6,18.3,1.6,7.9.8,2.6,3.8,3.7,3,.6h24.8c0,0,11.1.3,11.1.3l20.2.3,11.9-.3,5.7-1.2,5-1.9,3.3-1.7,3.3-2.9,2.9-3.9,1.4-5.4v-16.7s-1.1-5.2-1.1-5.2v-3.5c0,0-.7-6-.7-6l-1.6-9-1.5-8.5v-3.6c0,0-3.5-12.2-3.5-12.2l-1-3.3-1.7-4.2-3.4-10.3s-37-32.8-76.6.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M110.5,462.5c-19.1,3.9-45.7.5-68.5,1.5s-12.6-23.4-12.6-42c.8-14,.8-27.6,3.2-41.4,1.6-8.8,4.2-16.7,5.1-26,22.5-14.6,51.2-15.2,73.9,0,1.7,9.6,3.9,18.5,6.8,27.9,3.8,12.4,5.5,24.7,7.5,37.6,2.3,19.8,4.3,38.5-15.5,42.5Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M55.1,114.6h41.2s-18.9,97-41.2,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129.8,57.5l-1.1,32.3s-53.7-23,1.1-32.3Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.5,57l2.5,31s49.3-18.4-2.5-31Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '19.5 51.9 20.3 39.2 26.5 33.9 36.8 31.8 56.4 31.6 72.8 30.2 93.2 31.3 107.1 33.4 118.2 38.1 124 41.9 127.1 46.4 128.2 50.9 128.7 52.1 19.5 51.9',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M35.9,153.2s39.6,41.8,79.8,0l-1.5,9.9s-32.9,35.8-76.2,0l-2.1-9.9Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M56.4,31.6l-20.7.4-9.5,2.2-6,5.1-.8,12.8v5l2.5,31,3.3,22.4,3.4,16.1,3.7,12.3,2.3,7c19.3,0,21.7-114.1,21.7-114.1Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M93.2,31.3l13.9,2.1,11.1,4.6,5.6,3.7,3.4,4.8,1.5,5.5,1.1,5.4-.3,23.4-2.1,19.6-2.3,13.3-2.9,12.9-4.7,17.3c-19.7,0-24.3-112.7-24.3-112.7Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M35.9,153.2l-1.2-7.5-6-19.3-3.9-17.8-2.8-20.6-1.2-13-1.3-15.9v-7.1s.7-12.9.7-12.9l6.3-5.2,9.3-2.1,20.4-.3,16.5-1.4,20.2,1.1,14.2,2.1,10.8,4.6,5.9,3.8,3.2,4.8,1.5,5.5,1.1,5.4-.3,23.4-.9,8.9-1.2,11.1-.3,2-1.5,8.7-2.2,10.2-4.1,16.2-1.7,6-1.8,9.2s-35.7,42.6-79.8,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M95.3,170.7c-11.9,9.2-26.3,9.2-38.2,1-8.9-6.1-15.7-14.1-21.4-23.4-6.2-16.2-9.6-32.6-12.1-49.8s-4.3-35.3-3.7-53.5c.5-15.1,18.5-11.4,34-13,20-2.1,39.7-2,58.8,4.2s12.5,6,14.5,12.3c7.5,23.6-2.9,68.5-9.9,95.2-5.2,10.3-12.5,19.6-22,27Z',
			},
		},
	},
};
